import { useTranslation } from 'react-i18next';
import { ca, es, fr, it, enUS } from 'date-fns/locale';
import type { Locale } from 'date-fns';

// date-fns formats in English unless a locale is handed to it explicitly, so
// every user-facing `format()` needs one. Three components used to build this
// map inline and the rest of the app simply forgot, which is why dates read
// "Sat, Oct 10" and "JULY 2026" with the UI in Spanish.
const LOCALES: Record<string, Locale> = { ca, es, fr, it, en: enUS };

/** date-fns locale for a given i18n language tag. Falls back to English. */
export function getDateLocale(language: string | undefined): Locale {
  if (!language) return enUS;
  return LOCALES[language] ?? LOCALES[language.split('-')[0]] ?? enUS;
}

/** date-fns locale for the language the UI is currently rendered in. */
export function useDateLocale(): Locale {
  const { i18n } = useTranslation();
  return getDateLocale(i18n.language);
}
